import axios from 'axiosConfig';

export const deleteZoning = (ZoningID) => axios.delete(`/api/zoning/deletezoning/${ZoningID}`);

export const addZoning = (newZoning) => axios.post("/api/zoning/addzoning", newZoning, {});

export const getAllZoning = () => axios.get("/api/zoning/getzonings", {});

export const updateZoning = (zoning) => axios.put("/api/zoning/updatezoning", zoning, {});

export const reactivateZoning = (id) => axios.put(`/api/zoning/reactivatezoning/${id}`);

